import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import { Flex, Relative, Text } from "pcln-design-system";
import { LinkContainer, LoadMoreContainer } from "./LoadMore.styles.js";
import LoadMoreIcon from "./LoadMoreIcon.js";
const LoadMore = ({ onLoadMore })=>/*#__PURE__*/ jsx(LoadMoreContainer, {
        p: 2,
        displayCheckoutBtn: false,
        children: /*#__PURE__*/ jsx(Flex, {
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            children: /*#__PURE__*/ jsxs(Relative, {
                textAlign: 'center',
                width: "100%",
                children: [
                    /*#__PURE__*/ jsx(LinkContainer, {
                        onClick: onLoadMore,
                        children: /*#__PURE__*/ jsx(LoadMoreIcon, {})
                    }),
                    /*#__PURE__*/ jsx(LinkContainer, {
                        children: /*#__PURE__*/ jsx(Text, {
                            mt: 2,
                            fontSize: 2,
                            color: "text.base",
                            onClick: onLoadMore,
                            children: "More Hotels"
                        })
                    })
                ]
            })
        })
    });
const LoadMore_LoadMore = LoadMore;
export { LoadMore_LoadMore as default };
